module.exports = __webpack_public_path__ + "img/headBg2.247bf1e7.png";